import { render, staticRenderFns } from "./SfRating.vue?vue&type=template&id=2f0ac040&"
import script from "./SfRating.vue?vue&type=script&lang=js&"
export * from "./SfRating.vue?vue&type=script&lang=js&"
import style0 from "./SfRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports